export const downloadFile = (data: string, fileName: string, type: string) => {
  const a = document.createElement("a");
  a.setAttribute("style", "display: none");
  document.body.appendChild(a);
  const blob = new Blob([data], { type });
  const url = window.URL.createObjectURL(blob);
  a.href = url;
  a.download = fileName;
  a.click();
  window.URL.revokeObjectURL(url);
};

/** Expects a URL served with `Content-Disposition: attachment` so the browser saves it in place. */
export const downloadUrl = (url: string) => {
  const a = document.createElement("a");
  a.href = url;
  a.click();
};
